import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.77 18.25a.44.44 0 0 0 .316-.14l.808-.774q.105-.142.106-.316a.38.38 0 0 0-.106-.282l-4.289-4.289a.38.38 0 0 0-.28-.105h-.493a7.6 7.6 0 0 0 1.318-2.215 7.1 7.1 0 0 0 .475-2.566q0-2.004-.984-3.674a7.4 7.4 0 0 0-2.655-2.655Q9.316.25 7.312.25t-3.673.984A7.4 7.4 0 0 0 .984 3.89Q0 5.559 0 7.563t.984 3.673a7.4 7.4 0 0 0 2.655 2.655q1.67.984 3.673.984A7.1 7.1 0 0 0 9.88 14.4a7.6 7.6 0 0 0 2.215-1.318v.492q0 .141.105.281l4.29 4.254q.105.141.28.141m-9.458-5.062a5.5 5.5 0 0 1-2.812-.756 5.6 5.6 0 0 1-2.057-2.057 5.5 5.5 0 0 1-.756-2.812q0-1.512.756-2.813A5.6 5.6 0 0 1 4.5 2.693a5.5 5.5 0 0 1 2.812-.755q1.512 0 2.813.755a5.6 5.6 0 0 1 2.057 2.057q.755 1.3.755 2.813a5.5 5.5 0 0 1-.755 2.812 5.6 5.6 0 0 1-2.057 2.057 5.5 5.5 0 0 1-2.813.756"
    }, null, -1)
  ]))]))
}
export default { render: render }